import { all, takeEvery, fork, call, put } from 'redux-saga/effects';
import axios from 'axios';
import isFunction from 'lodash/isFunction';

import actions from './actions';
import { handleError } from '../../errorHandler';
import { API_HOST } from '../../constants';

const API_URL = `${API_HOST}/api/payment`;
const ITEM_API_URL = `${API_HOST}/api/payment/item`;
const SERVICE_API_URL = `${API_HOST}/api/payment/service`;

function* createPaymentItem() {
  yield takeEvery(actions.CREATE_PAYMENT_ITEM, function* (action) {
    const { formData, onSuccess } = action;
    try {
      const res = yield call([axios, 'post'], ITEM_API_URL, formData);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.CREATE_PAYMENT_ITEM_ENDED });
    }
  });
}

function* updatePaymentItem() {
  yield takeEvery(actions.UPDATE_PAYMENT_ITEM, function* (action) {
    const { formData, onSuccess } = action;
    try {
      const res = yield call([axios, 'put'], ITEM_API_URL, formData);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.UPDATE_PAYMENT_ITEM_ENDED });
    }
  });
}

function* searchPaymentItems() {
  yield takeEvery(actions.SEARCH_PAYMENT_ITEMS, function* (action) {
    const { parameters, onSuccess } = action;
    try {
      const res = yield call([axios, 'get'], `${ITEM_API_URL}?${parameters.toString()}`);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.SEARCH_PAYMENT_ITEMS_ENDED });
    }
  });
}

function* createPaymentService() {
  yield takeEvery(actions.CREATE_PAYMENT_SERVICE, function* (action) {
    const { formData, onSuccess } = action;
    try {
      const res = yield call([axios, 'post'], SERVICE_API_URL, formData);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.CREATE_PAYMENT_SERVICE_ENDED });
    }
  });
}

function* updatePaymentService() {
  yield takeEvery(actions.UPDATE_PAYMENT_SERVICE, function* (action) {
    const { formData, onSuccess } = action;
    try {
      const res = yield call([axios, 'put'], SERVICE_API_URL, formData);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.UPDATE_PAYMENT_SERVICE_ENDED });
    }
  });
}

function* findPaymentService() {
  yield takeEvery(actions.FIND_PAYMENT_SERVICE, function* (action) {
    const { id, onSuccess } = action;
    try {
      const res = yield call([axios, 'get'], `${SERVICE_API_URL}/${id}`);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.FIND_PAYMENT_SERVICE_ENDED });
    }
  });
}

function* searchPaymentServices() {
  yield takeEvery(actions.SEARCH_PAYMENT_SERVICES, function* (action) {
    const { parameters, onSuccess } = action;
    try {
      const res = yield call([axios, 'get'], `${SERVICE_API_URL}?${parameters.toString()}`);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.SEARCH_PAYMENT_SERVICES_ENDED });
    }
  });
}

function* refundPayment() {
  yield takeEvery(actions.REFUND_PAYMENT, function* (action) {
    const { formData, onSuccess } = action;
    try {
      const res = yield call([axios, 'put'], `${API_URL}/refund`, formData);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.REFUND_PAYMENT_ENDED });
    }
  });
}

function* redeemPayment() {
  yield takeEvery(actions.REDEEM_PAYMENT, function* (action) {
    const { formData, onSuccess } = action;
    try {
      const res = yield call([axios, 'put'], `${API_URL}/redeem`, formData);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.REDEEM_PAYMENT_ENDED });
    }
  });
}

function* searchPaymentPaymentTradeRecords() {
  yield takeEvery(actions.SEARCH_PAYMENT_TRADE_RECORD, function* (action) {
    const { parameters, onSuccess } = action;
    try {
      const res = yield call([axios, 'get'], `${API_URL}/trade?${parameters.toString()}`);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.SEARCH_PAYMENT_TRADE_RECORD_ENDED });
    }
  });
}

function* searchPaymentPaymentRedeemRecords() {
  yield takeEvery(actions.SEARCH_PAYMENT_REDEEM_RECORD, function* (action) {
    const { parameters, onSuccess } = action;
    try {
      const res = yield call([axios, 'get'], `${API_URL}/redeem?${parameters.toString()}`);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.SEARCH_PAYMENT_REDEEM_RECORD_ENDED });
    }
  });
}

function* findPayment() {
  yield takeEvery(actions.FIND_PAYMENT, function* (action) {
    const { id, onSuccess } = action;
    try {
      const res = yield call([axios, 'get'], `${API_URL}/${id}`);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.FIND_PAYMENT_ENDED });
    }
  });
}

function* searchPayments() {
  yield takeEvery(actions.SEARCH_PAYMENTS, function* (action) {
    const { parameters, onSuccess } = action;
    try {
      const res = yield call([axios, 'get'], `${API_URL}?${parameters.toString()}`);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.SEARCH_PAYMENTS_ENDED });
    }
  });
}

function* createFakePayment() {
  yield takeEvery(actions.CREATE_FAKE_PAYMENT, function* (action) {
    const { onSuccess } = action;
    try {
      const res = yield call([axios, 'post'], `${API_URL}/fakePayment`, []);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.CREATE_FAKE_PAYMENT_ENDED });
    }
  });
}

function* updatePaymentServiceStoreFields() {
  yield takeEvery(actions.UPDATE_PAYMENT_SERVICE_STORE_FIELDS, function* (action) {
    const { formData, onSuccess } = action;
    try {
      const res = yield call([axios, 'put'], `${SERVICE_API_URL}/storeFields`, formData);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.UPDATE_PAYMENT_SERVICE_STORE_FIELDS_ENDED });
    }
  });
}

function* searchPaymentServiceStoreFields() {
  yield takeEvery(actions.SEARCH_PAYMENT_SERVICE_STORE_FIELDS, function* (action) {
    const { parameters, onSuccess } = action;
    try {
      const res = yield call(
        [axios, 'get'],
        `${SERVICE_API_URL}/storeFields?${parameters.toString()}`,
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.SEARCH_PAYMENT_SERVICE_STORE_FIELDS_ENDED });
    }
  });
}

function* manuallyRefundPayment() {
  yield takeEvery(actions.MANUALLY_REFUND_PAYMENT, function* (action) {
    const { id, onSuccess } = action;
    try {
      const res = yield call([axios, 'post'], `${API_URL}/${id}/manuallyRefund`);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.MANUALLY_REFUND_PAYMENT_ENDED });
    }
  });
}

function* rejectRefundPayment() {
  yield takeEvery(actions.REJECT_REFUND_PAYMENT, function* (action) {
    const { id, onSuccess } = action;
    try {
      const res = yield call([axios, 'post'], `${API_URL}/${id}/rejectRefund`);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.REJECT_REFUND_PAYMENT_ENDED });
    }
  });
}

function* updatePaymentDetailWithThirdParty() {
  yield takeEvery(actions.UPDATE_PAYMENT_DETAIL_WITH_THIRD_PARTY, function* (action) {
    const { data, onSuccess } = action;
    try {
      const res = yield call([axios, 'put'], `${API_URL}/updatePaymentDetailWithThirdParty`, data);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.UPDATE_PAYMENT_DETAIL_WITH_THIRD_PARTY_ENDED });
    }
  });
}

export default function* rootSaga() {
  yield all([
    fork(createPaymentItem),
    fork(updatePaymentItem),
    fork(searchPaymentItems),
    fork(createPaymentService),
    fork(updatePaymentService),
    fork(findPaymentService),
    fork(searchPaymentServices),
    fork(refundPayment),
    fork(redeemPayment),
    fork(searchPaymentPaymentTradeRecords),
    fork(searchPaymentPaymentRedeemRecords),
    fork(findPayment),
    fork(searchPayments),
    fork(createFakePayment),
    fork(updatePaymentServiceStoreFields),
    fork(searchPaymentServiceStoreFields),
    fork(manuallyRefundPayment),
    fork(rejectRefundPayment),
    fork(updatePaymentDetailWithThirdParty),
  ]);
}
